<template>
  <BaseButton
    :active="active"
    active-color="secondary"
    :disabled="disabled"
    new-design
    @click="emit('click')"
  >
    <div class="tw:flex tw:flex-1 tw:items-center tw:gap-2 tw:px-3 tw:py-2">
      <BaseIcon
        class="tw:text-2xl"
        :icon="icon"
      />

      <div
        class="tw:flex-1 tw:text-left tw:text-base"
        :class="{ 'tw:font-bold': active }"
      >
        {{ label }}
      </div>

      <Tag
        v-if="filterCount"
        color="secondary"
        hide-cursor
        hide-remove-button
        :label="filterCount"
        rounded
      />

      <BaseIcon
        v-if="arrow"
        class="tw:text-2xl"
        icon="right-arrow"
      />

      <StreemTooltip v-if="tooltip">
        {{ tooltip }}
      </StreemTooltip>
    </div>
  </BaseButton>
</template>

<script setup lang="ts">
import { BaseButton, BaseIcon, Tag } from "shared/components/base";
import StreemTooltip from "shared/components/base/StreemTooltip.vue";

interface StreamFiltersMenuButtonProps {
  icon: string;
  label: string;
  active?: boolean;
  arrow?: boolean;
  filterCount?: number;
  disabled?: boolean;
  tooltip?: string;
}

defineProps<StreamFiltersMenuButtonProps>();

const emit = defineEmits(["click"]);
</script>
